const validateSelectionListItemDescription = (description: string) => {
  if (description?.length > 255) {
    return 'Description cannot be longer than 255 characters';
  }
  return '';
};

export default validateSelectionListItemDescription;
